import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type QuotesDto = ClientInferResponseBody<typeof contract.quoteRequests.findAllQuotes>;

export const fetchQuoteRequestsQuotes = async (
  id: string | undefined,
): Promise<QuotesDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.quoteRequests.findAllQuotes.query({
    params: { id },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
